import { useAuthStore } from '../stores/authStore';
import type { ChatContext, ChatResponse } from '@mise/shared';

const API_URL = import.meta.env.VITE_API_URL || 'https://gleaming-elegance-production-d593.up.railway.app/api';
const API_BASE = `${API_URL}/v1`;

interface ConversationMessage {
  role: 'user' | 'assistant';
  content: string;
}

export async function sendChatMessage(
  text: string,
  context: Omit<ChatContext, 'restaurantId'>,
  conversationHistory: ConversationMessage[]
): Promise<ChatResponse> {
  const token = useAuthStore.getState().token;

  try {
    const response = await fetch(`${API_BASE}/chat/message`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        message: text,
        context,
        conversationHistory,
      }),
    });

    if (!response.ok) {
      if (response.status === 401) {
        useAuthStore.getState().logout(true);
      }
      const error = await response.json().catch(() => ({}));
      return {
        success: false,
        error: error.error || { code: 'REQUEST_FAILED', message: 'Request failed' },
      };
    }

    return await response.json();
  } catch (error) {
    console.error('Chat request failed:', error);
    return {
      success: false,
      error: { code: 'NETWORK_ERROR', message: 'Network request failed' },
    };
  }
}
